import React from 'react';

import Button from '../../Shared/UI/Button/components/Button';
import EditPencilIcon from '../../Shared/UI/EditPencilIcon/components/EditPencilIcon';
import TrashCanIcon from '../../Shared/UI/TrashCanIcon/components/TrashCanIcon';

import { useProfileState, useProfileActions } from './ProfileContext';

import { ReadOnlyDocumentContent } from '../../RichTextEditor';
import { monthNameFromNumber } from '../../Shared/timeHelpers';

import styles from './ProfileUserExperience.module.scss';

const hasVersionDocument = (experience) => {
  const documentComponents = experience?.latestVersion?.documentComponents;
  return Boolean(
    documentComponents
    && typeof documentComponents === 'object'
    && !Array.isArray(documentComponents)
    && Object.keys(documentComponents).length > 0
  );
};

const ProfileUserExperience = ({ experience }) => {
  const profileState = useProfileState();
  const { openUpdateUserExperienceModal, openDeleteUserExperienceModal } = useProfileActions();

  const dateRangeFor = (experience) => {
    const startMonth = monthNameFromNumber(experience.startMonth);
    const startDate = `${startMonth} ${experience.startYear}`;

    let endDate = 'Today';

    if (experience.endMonth && experience.endYear) {
      const endMonth = monthNameFromNumber(experience.endMonth);
      endDate = `${endMonth} ${experience.endYear}`;
    }

    return `${startDate} - ${endDate}`;
  };

  return (
    <div key={experience.id} className={styles.userExperience}>
      <div className={styles.userExperienceTitleContainer}>
        <p className={styles.title}>{experience.title}</p>
        {profileState?.user?.isAuthenticatedUser && (
          <div className={styles.buttonContainer}>
            <Button
              variant="ghost"
              icon={<EditPencilIcon />}
              iconOnly
              aria-label="Edit Experience"
              onClick={() => {
                if (profileState?.user?.isAuthenticatedUser) {
                  openUpdateUserExperienceModal(experience);
                }
              }}
            />
            <Button
              variant="ghost"
              icon={<TrashCanIcon />}
              iconOnly
              aria-label="Delete Experience"
              onClick={() => {
                if (profileState?.user?.isAuthenticatedUser) {
                  openDeleteUserExperienceModal(experience);
                }
              }}
            />
          </div>
        )}
      </div>
      <p className={styles.biopharmaGroupName}>{experience.biopharmaGroupName}</p>
      <p className={styles.dateRange}>{dateRangeFor(experience)}</p>
      {hasVersionDocument(experience) ? (
        <div className={styles.description}>
          <ReadOnlyDocumentContent
            documentComponents={experience.latestVersion.documentComponents}
            classNames={{ paragraph: styles.descriptionParagraph }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ProfileUserExperience;
